export default {
    init(selector, config) {
    },
    finalize() {
        let pdf_created = false;

        const enrolment_id = $('#enrolmentId').data('enrolmentId');
        const certificate_type = $('#enrolmentId').data('certificateType');
        $.ajax({
            type: "POST",
            url: ajaxdta.ajaxurl + "?action=process_dta_certificate",
            data: {
                enrolment_id,
                certificate_type
            },
            data_type: 'JSON',
                success: function (data, status, xhr) {
                    pdf_created = true;
                }
        });

        $(".redirect-circle p").on("animationend", function(){
            const encrypted_query_vars = $('#queryVars').val();
            const a = document.createElement('a');
            a.href = `/${certificate_type}-certificate/${encrypted_query_vars}/`;
            const interval = setInterval(() => {
                if (pdf_created){
                    a.click();
                    clearInterval(interval);
                }
            }, 300)

        })
    }
}


// WEBPACK FOOTER //
// ./scripts/routes/generate-course-certificate.js